import React, { useEffect, useState, useMemo, useContext } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";
import { toastWarn } from "../../../common/Toast";
import { Box } from "@mui/material";
import { checkUserPermission } from "../../../common/UserPermission";
import { Noimage } from "../../../common/imagePath";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import Reportcurrencysymbols from "../../../common/Reportcurrencysymbols";

const PurchaseByCategories = (props) => {
  let PERMISSION_SHOW_COST_PRICE = "show-cost-price";
  let PERMISSION_SHOW_PROFIT_PRICE = "show-profit-price";
  const locationid = localStorage.getItem("Location");
  const token = localStorage.getItem("Token");

  const searchParams = new URLSearchParams(window.location.search);
  let iBrandId = searchParams.get("brandid") || 0;
  let iCategoryId = searchParams.get("categoryid") || 0;
  let iStartDate = searchParams.get("startdate") || "";
  let iEndDate = searchParams.get("enddate") || "";
  let iShowNonZero = searchParams.get("shownonzero") || 0;
  let iShowDeletedItems = searchParams.get("showdeleteditems") || 0;
  let iShowParentItem = searchParams.get("showparentItem") || 0;
  let iselectedperiod = searchParams.get("selectedperiod") || 7;
  let iSelectedItems = searchParams.get("selectedItems") || [];

  const [callAPi, setCallApi] = useState(false);
  const {
    CurrencySymbol,
    FractionDigits,
    dateFormate,
    ReportViewPermission,
    currencySymbolLocation,
  } = useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [categories, setCategories] = useState([]);
  const [categoriesId, setCategoriesId] = useState([]);
  const [customerid, setcustomerid] = useState(0);
  const [categoryData, setCategoryData] = useState([]);
  const [locationdropdown, setLocationDropdown] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [checkbox, setCheckBox] = useState({
    showNonZero: false,
    showDeletedItems: false,
    showParentItem: false,
  });
  const [brands, setBrands] = useState([]);
  const [brandId, setBrandId] = useState([]);
  const [showMoreFilters, setShowMoreFilters] = useState(false);
  const [searchItemName, setSearchItemName] = useState("");

  Number(locationid);

  const [classicView, setClassicView] = useState(true);
  console.log(categoriesId,"categoriescategoriescategories")

  useEffect(() => {
      setBrandId(iBrandId);
          setCategoriesId(
      Array.isArray(iCategoryId)
        ? iCategoryId.map(Number)
        : typeof iCategoryId === "string" && iCategoryId.includes(",")
        ? iCategoryId.split(",").map((id) => Number(id.trim()))
        : [Number(iCategoryId)]
    );
      // setCategoriesId(iCategoryId);
      setStartDate(iStartDate);
      setEndDate(iEndDate);
      setCheckBox({
        showNonZero: iShowNonZero == 0 ? false : true,
        showDeletedItems: iShowDeletedItems == 0 ? false : true,
        showParentItem: iShowParentItem == 0 ? false : true,
      });
      setSelectReport(iselectedperiod);
      setSelectedItems(iSelectedItems);
      setCallApi(true);
    // }
  }, []);

  useEffect(() => {
    if (
      iCategoryId &&
      categoriesId.length > 0 &&
      startdate !== "" &&
      enddate !== ""
    ) {
      apiCall();
    }
  }, [categoriesId, startdate, enddate, checkbox, selectReport, selectedItems]);

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value === 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const handelItemSearch = (value) => {
    if (value != "") {
      setSuggestions([]);
      axios
        .get(
          `${
            config.itemsBaseUrl
          }/items/searchforaccount?searchparam=${encodeURIComponent(
            value
          )}&iscategory=${0}&customerid=${0}&supplierid=${0}&locationid=${locationid}&itemsearchtype=sale&isservice=${1}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log(res.data.ResponseData, "resdata2709");
          if (res.data.ResponseData.length > 0) {
            const modifiedData = res.data.ResponseData.map((item) => ({
              ...item,
              ID: item.ItemId,
              VariationId: item.VariationId,
              Name:
                item.VariationName != "" ? item.VariationName : item.ItemName,
              ImageURL: item.ImageName,
              Quantity:
                item.VariationId != 0
                  ? item.VariationQuantity
                  : item.Itemquantity,
              Categoryfullpath: item.CategoryName,
            }));
            setSuggestions(modifiedData);
            setLoading(false);
          } else {
            toastWarn("No Item Found");
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      setSuggestions([]);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      handelItemSearch(searchItemName);
    }, 1000);

    // Cleanup function to clear the timeout if the component unmounts
    // or if searchItemName changes before the delay completes
    return () => {
      clearTimeout(handler);
    };
  }, [searchItemName]);

  useEffect(() => {
    if (callAPi) {
      setCallApi(false); // prevent repeated calls
      apiCall(); // call your API
    }
  }, [callAPi]);

  const apiCall = () => {
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/purchasebyinventorysubmodulesreport?&brandid=${brandId}&categoryid=${categoriesId}&tagid=0&manufacturerid=0&startdate=${startdate}&enddate=${enddate}&locationid=${locationid}&groupbytype=Category&shownonzero=${
          checkbox.showNonZero == true ? 1 : 0
        }&showdeleteditems=${
          checkbox.showDeletedItems == true ? 1 : 0
        }&showparentItem=${
          checkbox.showParentItem == true ? 1 : 0
        }&selectedItems=${encodeURIComponent(JSON.stringify(selectedItems))}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          const FilterData = res.data.ResponseData?.reportData?.map((el) => ({
            ...el,
            SubTotal: Number(el?.SubTotal),
            Total: Number(el?.Total),
            Discount: Number(el?.Discount),
            Profit: Number(el?.Profit),
            CurrentStockQty: Number(el?.CurrentStockQty),
            StockValue: Number(el?.StockValue),
            QuantityReceived: Number(el?.QuantityReceived),
          }));
          setResponseData(FilterData);
          const categoryFilteredData = res.data.ResponseData?.categoryData?.map(
            (el) => ({
              ...el,
              TotalSubTotal: Number(el?.TotalSubTotal),
              TotalSales: Number(el?.TotalSales),
              TotalDiscount: Number(el?.TotalDiscount),
              Profit: Number(el?.Profit),
              StockQty: Number(el?.StockQty),
              StockValue: Number(el?.StockValue),
              TotalQtySold: Number(el?.QuantityReceived),
            })
          );
          setCategoryData(categoryFilteredData);
          if (res.data.ResponseData.reportData.length > 0) {
            setLoading(false);
          } else {
            toastWarn("No Records Found!");
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        return;
      });
  };

  const handleInputClick = (item) => {
    console.log(item, "checkitemdata");

    const newItem = {
      ItemId: item.ItemId,
      variationId: item.VariationId,
      itemName: item.VariationId > 0 ? item.VariationName : item.ItemName,
    };

    setSelectedItems((prev) => {
      // Optional: avoid duplicates by ItemId + variationId
      const exists = prev.some(
        (i) =>
          i.ItemId === newItem.ItemId && i.variationId === newItem.variationId
      );
      return exists ? prev : [...prev, newItem];
    });
    setSearchItemName("");
  };

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        return res;
      });

    // Brand Dropdown
    axios
      .get(`${config.categoriesBaseUrl}/categories/categoriesdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const datalist = res.data.ResponseData.map((u) => {
          return { label: u.Name, value: u.ID };
        });
        setCategories(datalist);
      })
      .catch((err) => {
        console.log(err);
      });

    // Brand Dropdown
    axios
      .get(`${config.brandBaseUrl}/brands/brandsdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const datalist = res.data.ResponseData.map((u) => {
          return { label: u.Name, value: u.ID };
        });
        setBrands(datalist);
      })
      .catch((err) => {
        console.log(err);
      });

    // Location Dropdown
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };

  const columns = useMemo(() => [
    {
      header: "Parent Category",
      accessorKey: "CategoryParentName",
    },
    {
      header: "Category",
      accessorKey: "CategoryName",
    },
    {
      header: "Item",
      accessorKey: "ParentItem",
    },
    {
      header: "Item Name",
      accessorKey: "Item",
      Cell: ({ row }) => {
        const isVariationRow = row.original.IsParent == 1;
        return (
          <span style={{ fontWeight: isVariationRow ? "bold" : "normal" }}>
            {row.original.Item}
          </span>
        );
      },
    },
    {
      header: "Quantity Purchased",
      accessorKey: "QuantityReceived",
      Cell: ({ row }) => {
        const QtySold = row?.original?.QuantityReceived;
        if (QtySold == "0.00" || QtySold == "") {
          return 0.0;
        } else {
          return <div>{QtySold.toFixed(2)}</div>;
        }
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";

        const groupedColumn = table
          .getAllColumns()
          .find((col) => col.id === cell.row.groupingColumnId);

        const groupedColumnName = groupedColumn?.columnDef?.header;

        // If the grouping column is "Aging Period", render nothing
        if (groupedColumnName == "Aging Period") return null;
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        const columnId = cell.column.id;

        // Recursive function to walk all subRows and sum values (excluding variation rows)
        const getTotalExcludingVariations = (rows) => {
          return rows.reduce((sum, row) => {
            if (row.subRows?.length) {
              return sum + getTotalExcludingVariations(row.subRows);
            }

            const original = row.original || {};
            if (original.hasVariations === 1) return sum;

            const value = parseFloat(original[columnId] || 0);
            return sum + value;
          }, 0);
        };

        const total = getTotalExcludingVariations(cell.row.subRows || []);

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {total.toFixed(2)}
            </Box>
          </>
        );
      },
    },
    {
      header: "Bill SubTotal",
      accessorKey: "SubTotal",
      Cell: ({ row }) => {
        const SubTotal = row?.original?.SubTotal;
        if (SubTotal == "0.00" || SubTotal == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(SubTotal),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";

        const groupedColumn = table
          .getAllColumns()
          .find((col) => col.id === cell.row.groupingColumnId);

        const groupedColumnName = groupedColumn?.columnDef?.header;

        // If the grouping column is "Aging Period", render nothing
        if (groupedColumnName == "Aging Period") return null;
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        const columnId = cell.column.id;

        // Recursive function to walk all subRows and sum values (excluding variation rows)
        const getTotalExcludingVariations = (rows) => {
          return rows.reduce((sum, row) => {
            if (row.subRows?.length) {
              return sum + getTotalExcludingVariations(row.subRows);
            }

            const original = row.original || {};
            if (original.hasVariations === 1) return sum;

            const value = parseFloat(original[columnId] || 0);
            return sum + value;
          }, 0);
        };

        const total = getTotalExcludingVariations(cell.row.subRows || []);

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {total.toFixed(2)}
            </Box>
          </>
        );
      },
    },
    {
      header: "Discount",
      accessorKey: "Discount",
      Cell: ({ row }) => {
        const Discount = row?.original?.Discount;
        if (Discount == "0.00" || Discount == "") {
          return "";
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(Discount),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";

        const groupedColumn = table
          .getAllColumns()
          .find((col) => col.id === cell.row.groupingColumnId);

        const groupedColumnName = groupedColumn?.columnDef?.header;

        // If the grouping column is "Aging Period", render nothing
        if (groupedColumnName == "Aging Period") return null;
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        const columnId = cell.column.id;

        // Recursive function to walk all subRows and sum values (excluding variation rows)
        const getTotalExcludingVariations = (rows) => {
          return rows.reduce((sum, row) => {
            if (row.subRows?.length) {
              return sum + getTotalExcludingVariations(row.subRows);
            }

            const original = row.original || {};
            if (original.hasVariations === 1) return sum;

            const value = parseFloat(original[columnId] || 0);
            return sum + value;
          }, 0);
        };

        const total = getTotalExcludingVariations(cell.row.subRows || []);

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {total.toFixed(2)}
            </Box>
          </>
        );
      },
    },
    {
      header: "Bill Total",
      accessorKey: "Total",
      Cell: ({ row }) => {
        const Total = row?.original?.Total;
        if (Total == "0.00" || Total == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(Total),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";

        const groupedColumn = table
          .getAllColumns()
          .find((col) => col.id === cell.row.groupingColumnId);

        const groupedColumnName = groupedColumn?.columnDef?.header;

        // If the grouping column is "Aging Period", render nothing
        if (groupedColumnName == "Aging Period") return null;
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        const columnId = cell.column.id;

        // Recursive function to walk all subRows and sum values (excluding variation rows)
        const getTotalExcludingVariations = (rows) => {
          return rows.reduce((sum, row) => {
            if (row.subRows?.length) {
              return sum + getTotalExcludingVariations(row.subRows);
            }

            const original = row.original || {};
            if (original.hasVariations === 1) return sum;

            const value = parseFloat(original[columnId] || 0);
            return sum + value;
          }, 0);
        };

        const total = getTotalExcludingVariations(cell.row.subRows || []);

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {total.toFixed(2)}
            </Box>
          </>
        );
      },
    },

    // {
    //   header: "Profit",
    //   accessorKey: "Profit",
    //   enableSorting: false,
    //   size: "110",
    //   filterFn: "contains",
    //   Cell: ({ row }) => {
    //     const Profit = row?.original?.Profit;
    //     if (Profit == "0.00" || Profit == "") {
    //       return 0.0;
    //     } else {
    //       return (
    //         <div>
    //           {CurrencySymbols(
    //             Number(Profit),
    //             { CurrencySymbol },
    //             FractionDigits
    //           )}
    //         </div>
    //       );
    //     }
    //   },
    //   AggregatedCell: ({ cell, table }) => {
    //     const groupingColumnId = cell.row.groupingColumnId ?? "";
    //     const originalValue =
    //       cell.row.original?.[groupingColumnId] ??
    //       cell.row.subRows?.[0]?.original?.[groupingColumnId];

    //     // Retrieve the aggregated value
    //     const aggregatedValue = cell.getValue();

    //     console.log("Aggregated Value:", cell, aggregatedValue);

    //     // Check if the value is valid and format it
    //     const formattedValue =
    //       typeof aggregatedValue === "number" ? aggregatedValue : 0;

    //     return (
    //       <>
    //         <Box component="span" sx={{ fontWeight: "bold" }}>
    //           Total:
    //         </Box>{" "}
    //         <Box
    //           sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
    //         >
    //           {/* {formattedValue} */}
    //           {CurrencySymbols(
    //             Number(formattedValue),
    //             { CurrencySymbol },
    //             FractionDigits
    //           )}
    //         </Box>
    //       </>
    //     );
    //   },
    // },
    {
      header: "Current Stock Qty",
      Header: ({ column }) => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            textAlign: "center",
          }}
        >
          Current Stock as of {moment().format(dateFormate.toUpperCase())}
        </div>
      ),
      accessorKey: "CurrentStockQty",
      Cell: ({ row }) => {
        const CurrentStockQty = row?.original?.CurrentStockQty;
        if (CurrentStockQty == "0.00" || CurrentStockQty == "") {
          return 0.0;
        } else {
          return <div>{CurrentStockQty.toFixed(2)}</div>;
        }
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";

        const groupedColumn = table
          .getAllColumns()
          .find((col) => col.id === cell.row.groupingColumnId);

        const groupedColumnName = groupedColumn?.columnDef?.header;

        // If the grouping column is "Aging Period", render nothing
        if (groupedColumnName == "Aging Period") return null;
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        const columnId = cell.column.id;

        // Recursive function to walk all subRows and sum values (excluding variation rows)
        const getTotalExcludingVariations = (rows) => {
          return rows.reduce((sum, row) => {
            if (row.subRows?.length) {
              return sum + getTotalExcludingVariations(row.subRows);
            }

            const original = row.original || {};
            if (original.hasVariations === 1) return sum;

            const value = parseFloat(original[columnId] || 0);
            return sum + value;
          }, 0);
        };

        const total = getTotalExcludingVariations(cell.row.subRows || []);

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {total.toFixed(2)}
            </Box>
          </>
        );
      },
    },
    ...(checkUserPermission(PERMISSION_SHOW_COST_PRICE)
      ? [
          {
            header: "Stock Value",
            Header: ({ column }) => (
              <div
                style={{
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                  textAlign: "center",
                }}
              >
                Current Stock Value as of{" "}
                {moment().format(dateFormate.toUpperCase())}
              </div>
            ),
            accessorKey: "StockValue",
            size: 200,
            filterFn: "contains",
            Cell: ({ row }) => {
              return (
                <div>
                  {CurrencySymbols(
                    Number(row?.original?.StockValue),
                    { CurrencySymbol },
                    FractionDigits
                  )}
                </div>
              );
            },
            AggregatedCell: ({ cell, table }) => {
              const groupingColumnId = cell.row.groupingColumnId ?? "";

              const groupedColumn = table
                .getAllColumns()
                .find((col) => col.id === cell.row.groupingColumnId);

              const groupedColumnName = groupedColumn?.columnDef?.header;

              // If the grouping column is "Aging Period", render nothing
              if (groupedColumnName == "Aging Period") return null;
              const originalValue =
                cell.row.original?.[groupingColumnId] ??
                cell.row.subRows?.[0]?.original?.[groupingColumnId];

              const columnId = cell.column.id;

              // Recursive function to walk all subRows and sum values (excluding variation rows)
              const getTotalExcludingVariations = (rows) => {
                return rows.reduce((sum, row) => {
                  if (row.subRows?.length) {
                    return sum + getTotalExcludingVariations(row.subRows);
                  }

                  const original = row.original || {};
                  if (original.hasVariations === 1) return sum;

                  const value = parseFloat(original[columnId] || 0);
                  return sum + value;
                }, 0);
              };

              const total = getTotalExcludingVariations(cell.row.subRows || []);

              return (
                <>
                  <Box component="span" sx={{ fontWeight: "bold" }}>
                    Total:
                  </Box>{" "}
                  <Box
                    sx={{
                      color: "info.main",
                      display: "inline",
                      fontWeight: "bold",
                    }}
                  >
                    {total.toFixed(2)}
                  </Box>
                </>
              );
            },
          },
        ]
      : []),
  ]);

  const Classiccolumns = [
    {
      title: "Parent Category",
      field: "CategoryParentName",
      headerFilter: "input",
      defaultVisible: true,
      frozen: true,
    },
    {
      title: "Category",
      field: "CategoryName",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Item",
      field: "ParentItem",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Item Name",
      field: "Item",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Quantity Purchased",
      field: "QuantityReceived",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
    },
    {
      title: "Bill SubTotal",
      headerFilter: "input",
      field: "SubTotal",
      defaultVisible: true,
      bottomCalc: "sum",
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },

      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue(); // sum of all SaleTotal
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Discount",
      headerFilter: "input",
      field: "Discount",
      defaultVisible: true,
      bottomCalc: "sum",
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },

      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue(); // sum of all SaleTotal
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Bill Total",
      headerFilter: "input",
      field: "Total",
      defaultVisible: true,
      bottomCalc: "sum",
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },

      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue(); // sum of all SaleTotal
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: `Current Stock As Of ${moment().format(
        dateFormate.toUpperCase()
      )}`,
      field: "CurrentStockQty",
      headerFilter: "input",
      bottomCalc: "sum",
      defaultVisible: true,
      //  topCalcFormatter: function (cell) {
      //   const totalValue = cell.getValue();
      //   if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
      //     return `${CurrencySymbol}0.0`;
      //   }

      //   return Reportcurrencysymbols(
      //     Number(totalValue),
      //     { CurrencySymbol },
      //     FractionDigits,
      //     currencySymbolLocation
      //   );
      // },
      // formatter: function (cell) {
      //   const value = cell.getValue();
      //   if (value == "0.00" || value === "") {
      //     return `${CurrencySymbol}0.0`;
      //   }
      //   return Reportcurrencysymbols(
      //     Number(value),
      //     { CurrencySymbol },
      //     FractionDigits,
      //     currencySymbolLocation
      //   );
      // },
    },
    ...(checkUserPermission(PERMISSION_SHOW_COST_PRICE)
      ? [
          {
            title: `Current Stock Value As Of ${moment().format(
              dateFormate.toUpperCase()
            )}`,
            field: "StockValue",
            headerFilter: "input",
            bottomCalc: "sum",
            defaultVisible: true,
            topCalcFormatter: function (cell) {
              const totalValue = cell.getValue();
              if (
                totalValue == "0.00" ||
                totalValue === "" ||
                totalValue == null
              ) {
                return `${CurrencySymbol}0.0`;
              }

              return Reportcurrencysymbols(
                Number(totalValue),
                { CurrencySymbol },
                FractionDigits,
                currencySymbolLocation
              );
            },
            formatter: function (cell) {
              const value = cell.getValue();
              if (value == "0.00" || value === "") {
                return `${CurrencySymbol}0.0`;
              }
              return Reportcurrencysymbols(
                Number(value),
                { CurrencySymbol },
                FractionDigits,
                currencySymbolLocation
              );
            },
          },
        ]
      : []),
  ];

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const handleDropdownchange = (selectedOptions) => {
    const items = selectedOptions?.map((opt) => opt.data) || [];
    setSelectedItems(items);
  };

  const onCheckBoxChange = (event, type) => {
    console.log(event, "checkevent");

    if (type == "NonZero") {
      setCheckBox({ ...checkbox, showNonZero: event.target.checked });
    } else if (type == "DeletedItems") {
      setCheckBox({ ...checkbox, showDeletedItems: event.target.checked });
    } else if (type == "ParentItem") {
      setCheckBox({ ...checkbox, showParentItem: event.target.checked });
    }
  };

  const selectOptions = selectedItems.map((item) => ({
    value: item.ItemId + "-" + item.variationId,
    label: item.itemName,
    data: item,
  }));

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">Purchase By Category</li>
              </ul>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-4">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-3">
              <label className="col-form-label col-md-3">Categories</label>
              <div className="row">
                <div className="col-md-12 z-4">
                  <Select
                    options={categories}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    isMulti={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    onChange={(selected) =>
                      setCategoriesId(selected?.map((e) => e.value) || [])
                    }
                    value={categories.filter((b) =>
                      categoriesId.includes(b.value)
                    )}
                    //onChange={(e) => setCategoriesId(e?.value)}
                    //value={categories.find((e) => e.value == categoriesId)}
                    className="custom-select-search"
                  />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between col-sm-6 gap-2">
              <div className="col-sm-6">
                <label className="col-form-label form-label">
                  Serach Items
                </label>
                <input
                  type="search"
                  placeholder="Search..."
                  // className="form-control-sm w-100 mt-1"
                  className="search-btn form-control form-control-sm w-100"
                  onChange={(e) => {
                    setSearchItemName(e.target.value);
                  }}
                  value={searchItemName}
                  style={{ width: "300px" }}
                />

                {suggestions?.length > 0 ? (
                  <>
                    <div className="dropdown">
                      <ul
                        className="dropdown-menu show dropdown-suggestion"
                        style={{
                          overflow: "auto",
                          width: "120% ",
                          maxWidth: "600px",
                        }}
                      >
                        {suggestions?.map((item) => (
                          <li
                            className="border-bottom"
                            key={item.ID}
                            onClick={(e) => handleInputClick(item)}
                          >
                            <Link
                              key={item.ID}
                              href="#"
                              class="dropdown-item"
                              data-name={item.Name?.toLowerCase()}
                            >
                              <img
                                src={item.ImageURL || Noimage}
                                onError={(e) => {
                                  e.currentTarget.src = Noimage;
                                }}
                                alt={item.Name}
                                className="img-thumbnail rounded-circle mr-4"
                                width="55"
                                height="55"
                                style={{
                                  height: "60px",
                                  objectFit: "contain",
                                }}
                              />
                              <div className="customer-info w-100">
                                <strong
                                  className="word-break-data"
                                  style={{
                                    fontWeight: "bold",
                                    color: "#333",
                                  }}
                                >
                                  {item.Name}{" "}
                                  {item.Name ? `(${item.Name})` : ""}
                                </strong>
                              </div>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </>
                ) : null}
              </div>
              <div className="col-sm-6">
                <label className="col-form-label form-label">
                  Selected Items
                </label>
                <Select
                  onChange={(selectedOptions) =>
                    handleDropdownchange(selectedOptions)
                  }
                  options={selectOptions}
                  value={selectOptions} // use same list as value when all selected
                  isMulti
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  isClearable={true}
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  className="custom-search-select"
                />
              </div>
            </div>
            {showMoreFilters && (
              <>
                <div className="col-sm-2">
                  <label className="col-form-label form-label">
                    Show Non Zero Items
                  </label>
                  <input
                    className="form-control form-check-input"
                    style={{ width: "1.5em", height: "1.5em" }}
                    type="checkbox"
                    checked={checkbox.showNonZero}
                    id="showNonZero"
                    name="showNonZero"
                    onChange={(e) => onCheckBoxChange(e, "NonZero")}
                  />
                </div>
                <div className="col-sm-2">
                  <label className="col-form-label form-label">
                    Show Deleted Items
                  </label>
                  <input
                    className="form-control form-check-input"
                    style={{ width: "1.5em", height: "1.5em" }}
                    type="checkbox"
                    checked={checkbox.showDeletedItems}
                    id="showDeletedItems"
                    name="showDeletedItems"
                    onChange={(e) => onCheckBoxChange(e, "DeletedItems")}
                  />
                </div>
                <div className="col-sm-2">
                  <label className="col-form-label form-label">
                    Show Parent Items
                  </label>
                  <input
                    className="form-control form-check-input"
                    style={{ width: "1.5em", height: "1.5em" }}
                    type="checkbox"
                    checked={checkbox.showParentItem}
                    id="showParentItem"
                    name="showParentItem"
                    onChange={(e) => onCheckBoxChange(e, "ParentItem")}
                  />
                </div>
                <div className="col-sm-3">
                  <label className="col-form-label col-md-3">Brands</label>
                  <div className="row">
                    <div className="col-md-12 z-3">
                      <Select
                        options={brands}
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        isClearable={true}
                        isMulti={true}
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        onChange={(selected) =>
                          setBrandId(selected?.map((e) => e.value) || [])
                        }
                        value={brands.filter((b) => brandId.includes(b.value))}
                        className="custom-select-search"
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
            <div className="col-auto" title="Advance Filter">
              <label className="col-form-label form-label"> </label>
              <Link
                className="form-control btn btn-sm btn-outline-dark mt-3"
                onClick={() => {
                  setShowMoreFilters(!showMoreFilters);
                }}
              >
                {showMoreFilters ? (
                  <i className="fa fa-arrow-up me-2 ms-2 mt-2"></i>
                ) : (
                  <i className="fa fa-arrow-down me-2 ms-2 mt-2"></i>
                )}
              </Link>
            </div>
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apiCall()}
              >
                Run Report
              </button>
            </div>
          </div>
          {responseData.length > 0 && (
            <>
              <div className="card mt-3">
                <div className="card-body">
                  <div className="container">
                    <div className="col-md-12 text-center " id="header">
                      <h6 class="p">SonarPos</h6>
                      <p className="fw-bold p-regular">Purchase By Category</p>
                      <div className="row mb-2">
                        <p>
                          Date:{" "}
                          {startdate === "" && enddate === ""
                            ? "All Data"
                            : moment(startdate).format(
                                `${dateFormate.toUpperCase()}`
                              ) +
                              " - " +
                              moment(enddate).format(
                                `${dateFormate.toUpperCase()}`
                              )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="table-responsive">
                    <div className="table mt-3"></div>
                    <div>
                      {ReportViewPermission == true ? (
                        <button
                          className="btn btn-secondary"
                          onClick={() => setClassicView(!classicView)}
                        >
                          {" "}
                          {classicView ? "Classic View" : "Morden View"}
                        </button>
                      ) : (
                        <></>
                      )}
                      {classicView ? (
                        <CommonTabular
                          Data={responseData}
                          columns={Classiccolumns}
                          Groupvalue={["CategoryName"]}
                          Reportname={"Purchase By Categories"}
                          frozenRowvalue={0}
                          layout={"fitDataFill"}
                          Onrefresh={() => apiCall()}
                        />
                      ) : (
                        <CommonMatrialReactTable
                          MainHeading="Sonar POS"
                          ReportHeading="Purchase By Brand"
                          columns={columns}
                          data={responseData}
                          startdate={startdate}
                          enddate={enddate}
                          columnGrouping={[
                            "CategoryParentName",
                            "CategoryName",
                            "ParentItem",
                          ]}
                          columnsVisibility={{}}
                          enableExpandAll={true}
                          enableExpanding={true}
                          expanded={true}
                          enableRowSelection={false}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default PurchaseByCategories;
